/* eslint-disable no-restricted-syntax */
import _t from 'i18n!nls/staff-management';

export type Roles = {
  [id: string]: {
    label: string;
    description: string;
    order: number;
  };
};

export const getRoles = (): Roles => ({
  'GSBm2NvdEemfBQqysZj-PA': {
    label: _t('Program API Administrator'),
    description: _t(
      'Allow staff member(s) to set up and manage the program’s automatic data sync with Coursera’s Degree API.'
    ),
    order: 4,
  },
  /* eslint-disable-next-line camelcase */
  g2_YUgjaEeuw4gpN_pH5aw: {
    label: _t('Program Staff'),
    description: _t('Allow staff member(s) to view the private program homepage for enrolled learners.'),
    order: 1,
  },
  'xPqAVsDZEey-nhLk5z3_xw': {
    label: _t('Program Administrator'),
    description: _t('Allow staff member(s) to manage the program, including all content.'),
    order: 0,
  },
  '0gb-c9MyEemPsgo2Up9EUg': {
    label: _t('Recruitment Staff'),
    description: _t(
      'Allow staff member(s) to view the private program homepage for enrolled learners and the Recruitment Dashboard.'
    ),
    order: 2,
  },
  '0d7dLtMyEem2zQ7VKWxX-A': {
    label: _t('Student Success Staff'),
    description: _t(
      'Allow staff member(s) to view the private program homepage for enrolled learners and the Student Success Dashboard.'
    ),
    order: 3,
  },
  '05hSUQ_jEeuSxQ4751py7Q': {
    label: _t('Institution Staff'),
    description: _t(
      'Allow staff member(s) to access and modify all content and settings within public course offerings, but not courses in degree programs or MasterTrack® Certificates.'
    ),
    order: 6,
  },
  '6pZ-H5nxEemYhRIASltr6g': {
    label: _t('Data Coordinator'),
    description: _t(
      'Allow staff member(s) to access and modify all content and settings as well as download research data exports for your institution.'
    ),
    order: 8,
  },
  '6qTWgZnxEem2zQ7GDg0ebg': {
    label: _t('Instructor'),
    description: _t(
      'Allow staff member to create new courses, but not edit courses they didn’t author. You can give them course staff permissions to do so.'
    ),
    order: 7,
  },
  JjXu2z80EeuEpRL3PHFRlw: {
    label: _t('Institution API Administrator'),
    description: _t(
      'Allow staff member(s) to set up and manage automatic data sync with Coursera’s Degree APIs for your institution.'
    ),
    order: 9,
  },
  '6oc745nxEem_VArHapF3VA': {
    label: _t('Partner Administrator'),
    description: _t('Allow staff member(s) to modify all content and settings for your institution.'),
    order: 5,
  },
  TpflCWU2Ee2nMQotOWEwuQ: {
    label: _t('Finance Admin'),
    description: _t(
      'Allow staff member(s) to view revenue share disbursement data of your institution’s content on the Coursera platform.'
    ),
    order: 10,
  },
});
